export default __webpack_public_path__ + "static/media/instagram.e2864370.svg";